<script setup lang="ts">
import { faXmark } from '@fortawesome/pro-light-svg-icons'
import { extractLabel, extractName } from '#shared/utils/solr-facet'
import { nodeTypeToLabels } from '~/utils/solr/search-utils'

const filterState = useSearchFilters({ resetPageOnFilterChange: true })
</script>

<template>
  <div v-if="filterState.totalFilters.value > 0" class="flex gap-2xs items-center flex-wrap w-full max-w-[837px] animate-fade">
    <template v-if="filterState.selectedContentTypes.value.length">
      <Chip
        v-for="value in filterState.selectedContentTypes.value"
        :key="value"
        size="small"
        variant="filled"
        color="moss"
        :icon-right="faXmark"
        :aria-label="`Filtrer etter innholdstype: ${value}`"
        @click="() => filterState.filterContentType(value)"
      >
        {{ nodeTypeToLabels(value) }}
      </Chip>
    </template>
    <template v-if="filterState.selectedLegalCategories.value.length">
      <Chip
        v-for="value in filterState.selectedLegalCategories.value"
        :key="value"
        size="small"
        variant="filled"
        color="moss"
        :icon-right="faXmark"
        :aria-label="`Filtrer etter rettsområde: ${extractLabel(value)}`"
        @click="() => filterState.filterLegalCategory(value)"
      >
        {{ extractLabel(value) }}
      </Chip>
    </template>
    <template v-if="filterState.selectedAuthors.value.length">
      <Chip
        v-for="value in filterState.selectedAuthors.value"
        :key="value"
        size="small"
        variant="filled"
        color="moss"
        :icon-right="faXmark"
        :aria-label="`Filtrer etter forfatter: ${extractName(value)}`"
        @click="() => filterState.filterAuthor(value)"
      >
        {{ extractName(value) }}
      </Chip>
    </template>
    <Chip
      v-if="filterState.totalFilters.value > 1"
      size="small"
      variant="outlined"
      color="moss"
      :icon-right="faXmark"
      aria-label="Fjern alle filtre"
      @click="filterState.resetFilters"
    >
      Fjern alle
    </Chip>
  </div>
</template>
